import { addDoc, getDocs, deleteDoc, collection, query, where, doc } from "firebase/firestore";
import { db, auth } from "../../config/firebase";
import { useEffect, useState } from "react";
import { Post } from "../home/Home";
import { Post as PostView } from "../Post/Post";
import { useAuthState } from "react-firebase-hooks/auth";

export const MyPosts = () => {
  const [postsList, setPostsList] = useState<Post[] | null>();

  const [user, loading, error] = useAuthState(auth);
  const [loadingVisisble, setLoadingVisisble] = useState<boolean>(false);

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  let delayTime = 20;

  const getPosts = async () => {
    try {
      console.log(user);
      setLoadingVisisble(true);
      await delay(delayTime);

      const postRef = collection(db, "posts");
      const userPosts = query(postRef, where("userId", "==", user?.uid));
      const data = await getDocs(userPosts);

      setPostsList(data.docs.map(doc => ({ ...doc.data(), id: doc.id })) as Post[]);
      setLoadingVisisble(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user) {
      getPosts();
    }
  }, [user]);
  return (
    <div>
      <h1>Your posts</h1>
      <div className='d-flex flex-column justify-content-center align-content-center mx-auto'>
        {postsList?.map(p => (
          <PostView post={p} refreshPosts={getPosts} />
        ))}
      </div>
      {loadingVisisble && (
        <div className='spinner-border my-2' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      )}
      {!loadingVisisble && (
        <button
          className='btn btn-secondary my-3'
          onClick={() => {
            delayTime = 500;
            getPosts();
          }}>
          Refresh &#x21bb;
        </button>
      )}
    </div>
  );
};
